const NfpImageModuleBaseURL = "https://nftcdn.daz3d.com/nfp/gen1/";

function NfpImageModule(ui, enabled) {
    this.cachedStatus = {};
    this.options = {};
    this.ui = ui;
    this.enabled = enabled;
    this.selectedToken = NftUpgrade.nullNft;
    this.selectedImage = null;
    this.location = "hero";

    this.overrideAvailable = {};
    this.available = {
        "default": "Default",
        "anim_001": "Animated",
        "full": "Full Body",
        "hip": "3/4 Body",
        "hip2": "Half Body",
        'lm-watch': 'Louis Moinet Space Revolution Watch',
        'clinique' : 'Clinique&trade; Background'
    };
    this.notAvailable = {
        'anim_001': ['1','7','16','30','37','42','85','112','250','552','565','575','576','670','1055','1113','1154','1234','1287','1298','1356','1408','1423','1583','1617','1944','2084','2104','2205','2239','2329','2388','2499','2505','2557','2657','2929','2935','3119','3207','3293','3483','3584','3644','3679','3875','3988','4006','4030','4042','4116','4269','4369','4462','4501','4512','4637','4774','4809','4897','4905','4941','4943','5085','5088','5287','5312','5397','5459','5576','5590','5688','5743','5762','5968','5972','6019','6128','6141','6195','6355','6394','6400','6427','6685','6925','6997','6999','7129','7313','7540','7575','7576','7582','7595','7596','7669','7705','7709','7759','7763','7816','7886','7919','7951','7985','8056','8148','8203','8208','8236','8238','8249','8318','8406','8431','8453','8582','8625','8680','8682','8690','8707','8859','8867','8880'],
        'lm-watch': false,
        'clinique': false,
    };

    this.name = "images";
    this.label = "Images";
    this.icon = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_37_182)">
                        <path d="M33.6094 40H6.38783C4.69413 39.9985 3.07021 39.3251 1.87257 38.1274C0.674941 36.9298 0.00146451 35.3059 0 33.6122V11.0197C0.000496222 10.119 0.320967 9.24771 0.904249 8.56135L7.06257 1.33286C7.41802 0.914975 7.86006 0.579335 8.35807 0.349192C8.85607 0.119048 9.39815 -0.00010257 9.94677 -1.47729e-05H33.6094C34.4494 -0.000741375 35.2812 0.163991 36.0575 0.484756C36.8338 0.80552 37.5393 1.27604 38.1338 1.86946C38.7282 2.46288 39.2 3.16758 39.5221 3.94332C39.8442 4.71905 40.0103 5.55065 40.0111 6.3906V33.6205C40.0074 35.3151 39.3311 36.939 38.1307 38.1352C36.9303 39.3315 35.3041 40.0022 33.6094 40ZM9.94677 1.93569C9.67846 1.93587 9.41339 1.99433 9.16989 2.107C8.92639 2.21968 8.71027 2.38391 8.53647 2.58832L2.37816 9.81678C2.0929 10.1527 1.93611 10.579 1.93571 11.0197V33.6205C1.93717 34.8008 2.4067 35.9324 3.24132 36.767C4.07594 37.6016 5.20751 38.0711 6.38783 38.0726H33.6094C34.195 38.0737 34.7751 37.9594 35.3165 37.7362C35.858 37.513 36.3501 37.1853 36.7649 36.7719C37.1796 36.3584 37.5088 35.8673 37.7337 35.3266C37.9585 34.7858 38.0746 34.2061 38.0754 33.6205V6.3906C38.0746 5.20979 37.6054 4.0775 36.7707 3.24229C35.936 2.40707 34.804 1.93716 33.6232 1.93569H9.94677Z"></path>
                        <path d="M6.77221 11.8327H0.965087V9.897H6.77221C7.12644 9.897 7.46617 9.75628 7.71665 9.5058C7.96713 9.25532 8.10785 8.91559 8.10785 8.56136V0.967849H10.0436V8.56136C10.0428 9.42875 9.69792 10.2604 9.08459 10.8737C8.47125 11.4871 7.6396 11.832 6.77221 11.8327Z"></path>
                        <path d="M35.4926 31.3529L27.3571 16.5641C27.1693 16.2255 26.8959 15.9421 26.5643 15.7422C26.2326 15.5423 25.8543 15.433 25.4671 15.4251C25.08 15.4173 24.6976 15.5112 24.3581 15.6975C24.0186 15.8838 23.734 16.1559 23.5327 16.4867L17.5762 26.4832C17.486 26.6395 17.3562 26.7694 17.1999 26.8596C17.0436 26.9499 16.8663 26.9975 16.6858 26.9976C16.5042 27.0106 16.3224 26.9758 16.1584 26.8968C15.9944 26.8177 15.854 26.697 15.7511 26.5468L13.2624 22.468C13.0649 22.1678 12.7955 21.9217 12.4787 21.7522C12.1619 21.5826 11.8077 21.495 11.4483 21.4974H11.4317C11.074 21.4924 10.7206 21.5765 10.4035 21.7421C10.0863 21.9077 9.81534 22.1495 9.61493 22.4459L3.88801 31.1676C3.69165 31.4559 3.57872 31.7928 3.56164 32.1412C3.54456 32.4896 3.624 32.836 3.79122 33.1421C3.97984 33.4821 4.25719 33.7645 4.5937 33.9593C4.93021 34.1541 5.31326 34.254 5.70204 34.2482H33.5707C33.94 34.2538 34.3045 34.1641 34.629 33.9878C34.9536 33.8115 35.2272 33.5545 35.4234 33.2416C35.5975 32.9597 35.6953 32.6375 35.7075 32.3064C35.7196 31.9753 35.6455 31.6468 35.4926 31.3529Z"></path>
                        <path d="M15.5576 11.0861C14.8881 11.0861 14.2337 11.2846 13.6771 11.6565C13.1205 12.0284 12.6867 12.5571 12.4305 13.1755C12.1743 13.794 12.1073 14.4745 12.2379 15.1311C12.3685 15.7877 12.6908 16.3908 13.1642 16.8641C13.6376 17.3375 14.2407 17.6599 14.8972 17.7905C15.5538 17.9211 16.2344 17.8541 16.8528 17.5979C17.4713 17.3417 17.9999 16.9079 18.3718 16.3512C18.7438 15.7946 18.9423 15.1402 18.9423 14.4708C18.9415 13.5733 18.5847 12.7129 17.9501 12.0783C17.3155 11.4437 16.455 11.0868 15.5576 11.0861Z"></path>
                    </g>
                    <defs>
                        <clipPath id="clip0_37_182">
                            <rect width="40" height="40"></rect>
                        </clipPath>
                    </defs>
                </svg>`;

    this.panel = `
                <h4 class="text-center fw-lighter my-3 panel-head">
                    Images
                </h4>
                <div class="purple-box p-3 panel-desc fs-6">
                    Select the image you’d like to display on OpenSea.
                </div>
                <div id="panel-images" class="h-100 overflow-auto">
                    <div id="dashboard_images" class="flex-grow-1 panel-items d-flex flex-wrap justify-content-between align-items-start">
                        
                    </div>
                </div>
                <div class="download-all p-3 panel-footer d-flex flex-column align-items-center">
                    <button class="submit opensea-update-image">Update your image on OpenSea</button>
                    <button class="mt-2 submit images-download-all">Download all</button>
                </div>
                `;
}

NfpImageModule.prototype.Init = async function () {
    this.initListeners();
}

NfpImageModule.prototype.Display = async function (nft, data = null) {
    if (!this.enabled || this.IsNftBlocked(nft)) {
        return;
    }
    if (this.selectedToken.equals(nft)) {
        await this.selectImage();
        return;
    }
    this.selectedToken = nft;
    this.selectedImage = null;
    dashboard_images.innerHTML = "";
    for (let i in this.available) {
        if (this.notAvailable[i] === true) {
            continue;
        } else if (this.notAvailable[i] === false) {
            if (!this.overrideAvailable.hasOwnProperty(i) || this.overrideAvailable[i].indexOf(this.selectedToken.token.toString()) === -1) {
                continue;
            }
        } else if (this.notAvailable.hasOwnProperty(i) && this.notAvailable[i].indexOf(this.selectedToken.token.toString()) !== -1) {
            continue;
        }
        this.addMedia(i, this.available[i]);
    }
    if (data && data.preselect) {
        const preimg = dashboard_images.querySelector(`[data-image="${data.preselect}"]`);
        if (preimg) {
            this.selectedImage = preimg;
            await this.selectImage();
        }
    }
}

NfpImageModule.prototype.IsNftBlocked = function (nft) {
    return false;
}

NfpImageModule.prototype.getImageURL = function (token, imageType = null) {
    if (imageType) {
        token = token.toString().padStart(4, '0');
        return `${NfpImageModuleBaseURL}t/${imageType}/${token}.png`;
    } else {
        return `${NfpImageModuleBaseURL}t/${token}`;
    }
}

NfpImageModule.prototype.getAnimationURL = function (token, imageType = null) {
    return `${NfpImageModuleBaseURL}a/${token}.mp4`;
}

NfpImageModule.prototype.addMedia = async function (imageType = '', name = 'Default') {
    if (imageType.substring(0, 4) === 'anim') {
        return this.addVideo(imageType, name);
    } else {
        return this.addImage(imageType, name);
    }
}

NfpImageModule.prototype.addOverride = async function (imageType, nft) {
    this.overrideAvailable[imageType] = nft.token;
}

NfpImageModule.prototype.onSelectToken = async function (nft) {
    this.overrideAvailable = {};
}

NfpImageModule.prototype.addVideo = async function (imageType = '', name = 'Default') {
    const base = this.getAnimationURL(this.selectedToken.token, imageType);

    const div = document.createElement("div");
    div.classList.add('img-container', 'w-50', 'pt-3');
    div.setAttribute('data-image', imageType);
    div.setAttribute('data-name', name);
    div.setAttribute('data-src', "name");
    div.innerHTML = `
                        <video class="mb-2" autoplay="false" muted loop width="200" height="200" style="width:100%; height: 100%">
                        <source src="${base}" type="video/mp4">
                        </video>
                        <p class="mb-1">${name}</p>
                        `;
    div.addEventListener('click', (e) => this.selectImage(e));
    dashboard_images.append(div);
}

NfpImageModule.prototype.addImage = async function (imageType = '', name = 'Default') {
    const base = this.getImageURL(this.selectedToken.token, imageType);

    const div = document.createElement("div");
    div.classList.add('img-container', 'w-50', 'pt-3');
    div.setAttribute('data-image', imageType);
    div.setAttribute('data-name', name);
    div.setAttribute('data-src', "name");
    div.innerHTML = `
                        <img class="mb-2" title="${name}" src="${base}" alt="placeholder img">
                        <p class="mb-1">${name}</p>
                        `;
    div.addEventListener('click', (e) => this.selectImage(e));
    dashboard_images.append(div);
}

NfpImageModule.prototype.selectImage = async function (e = null) {
    let isVideo = false;
    if (this.selectedImage) {

        this.selectedImage.classList.remove('selected');
    }
    if (e !== null) {
        isVideo = e.target.tagName === "VIDEO";
        if (e.target.tagName === "IMG" || e.target.tagName === "P" || isVideo) {
            this.selectedImage = e.target.parentNode;
        } else {
            this.selectedImage = e.target;
        }
    }
    if (!this.selectedImage) {
        return;
    }

    this.selectedImage.classList.add('selected');
    isVideo = this.selectedImage.getAttribute('data-image').substring(0, 4) === 'anim';
    this.ui.panel.reset();
    if (isVideo) {
        this.ui.panel.setSelectedVideo(this.selectedImage.querySelector('source').src);
    } else {
        this.ui.panel.setSelectedImage(this.selectedImage.querySelector('img').src);
    }
    this.ui.panel.addText('Show off your traits by changing your NFP image on OpenSea, or download image files to use as a PFP, wallpaper, etc.')
        .render();
}

NfpImageModule.prototype.download = async function (what) {
    const now = Math.floor(Date.now() / 1000);
    this.ui.auth(true).then(signature => {
        this.ui.loading(true);
        const hash = dazethutil.hashAll([what, this.selectedToken.token, dazethutil.me(), now, signature.Signature, signature.Nonce, signature.Tokens, signature.SigHash]);

        const data = {
            who: dazethutil.me(),
            sig: signature.Signature,
            sigHash: signature.SigHash,
            tokens: signature.Tokens,
            nonce: signature.Nonce.toString(),
            hash: hash,
            token: this.selectedToken.token,
            now: now.toString(10),
            what: what
        }

        const url = "/nft-api/nfp/gen1/download?" + (new URLSearchParams(data)).toString();
        document.location.href = url;
        this.ui.loading(false);
    });
}


NfpImageModule.prototype.save = async function (e) {
    const image = this.selectedImage.getAttribute('data-image');
    const now = Math.floor(Date.now() / 1000);
    const isAnimation = image.substring(0, 4) === 'anim';
    this.ui.signature.get(this.selectedToken.address, true).then(signature => {
        if (signature === false) {
            return;
        }
        this.ui.loading(true);
        const hash = dazethutil.hashAll([image, this.selectedToken.token, dazethutil.me(), now, signature.Signature, signature.Nonce, signature.Tokens, signature.SigHash]);
        const data = {
            who: dazethutil.me(),
            sig: signature.Signature,
            sigHash: signature.SigHash,
            tokens: signature.Tokens,
            nonce: signature.Nonce.toString(),
            hash: hash,
            token: this.selectedToken.token,
            now: now.toString(10),
            what: image
        }
        this.ui.modal.Processing('Image Change Processing', 'Your selected NFP PFP image change is currently being processed...');
        fetch(this.ui.upgrade.config.baseUrl + "/nft-api/nfp/gen1/swap", {
            method: 'POST',
            body: (new URLSearchParams(data)).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then((response) => {
            return response.json()
        }).then((res) => {
            this.ui.loading(false);
            if (res.status !== 201) {
                if (isAnimation) {
                    this.ui.selectedMeta.animation_url = this.getAnimationURL(this.selectedToken.token, image);
                }
                this.ui.displayHero(data.nonce);
                this.updateSelectedInventory(data.nonce);
                this.selectedImage = null;
                this.ui.panel.reset(true);
                this.ui.modal.View(
                    'Image Change Successful!',
                    'Your NFP PFP change has been completed. You will need to refresh MetaData on OpenSea to see this change.',
                    [
                        {
                            text: 'View NFP On OpenSea',
                            callback: () => {
                                window.open(`https://opensea.io/assets/${this.selectedToken.address}/${this.selectedToken.token}`);
                                return false;
                            }
                        },
                        {
                            text: 'Close',
                        }
                    ]
                );
            } else {
                this.ui.loading(false);
                this.ui.modal.Error('Image Change Error', 'Please try again later.');
                console.error(res);
            }
        }).catch((error) => {
            this.ui.modal.Error('Image Change Failed', 'Please try again later...');
            this.ui.loading(false);
            console.error(error)
        })
    });
}

NfpImageModule.prototype.Reset = async function () {
    dashboard_images.innerHTML = "";
}

NfpImageModule.prototype.updateSelectedInventory = function (cb) {
    const img = document.querySelector(`#invList a.nft[data-address="${this.selectedToken.address}"][data-id="${this.selectedToken.token}"] img`);
    let url = img.parentNode.getAttribute('data-img');
    if (url.indexOf('?') > -1) {
        url += `&_=${cb}`;
    } else {
        url += `?_=${cb}`;
    }
    img.src = url;
}

NfpImageModule.prototype.initListeners = function () {
    document.querySelector('.images-download-all').addEventListener('click', async e => {
        await this.download('thumbs');
    })

    document.querySelector('.opensea-update-image').addEventListener('click', e => this.save(e))
}
